import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeView,
    redirect: '/homeIndex',
    children: [
      {
        path: '/login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
      },
      {
        path: '/register',
        component: () => import(/* webpackChunkName: "register" */ '@/views/register.vue'),
      },
      {
        path: '/homeIndex',
        meta: {
          needAuth: true,
        },
        component: () => import(/* webpackChunkName: "HomeIndex" */ '@/views/HomeIndex.vue'),
      },
    ],
  },
  {
    path: '/admissionTicket',
    meta: {
      needAuth: true,
    },
    component: () => import(/* webpackChunkName: "AdmissionTicket" */ '@/views/AdmissionTicket2.vue'),
  },
  {
    path: '/admissionTicket/:id',
    meta: {
      needAuth: false,
    },
    component: () => import(/* webpackChunkName: "AdmissionTicket" */ '@/views/AdmissionTicket2.vue'),
  },
  {
    path: '*',
    meta: {
      needAuth: false,
      title: 'NotFound',
    },
    component: () => import(/* webpackChunkName: "NotFound" */ '@/views/404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // document.title = 'MyAPChina - ' + to.meta.title
    // if (to.meta.titleCustom === true) document.title = to.meta.title
  }
  if (!localStorage.getItem('token')) {
    if (to?.meta?.needAuth === true) {
      next('/login')
    } else {
      next()
    }
  } else {
    if (to.path === '/login' || to.path === '/register') {
      next('/')
    } else {
      next()
    }
  }
})

export default router
